import React, { useRef, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import usePrev from 'src/hooks/usePrev'
import { FormattedMessage } from 'react-intl'
import { mapValues } from 'lodash'
import { sendInvite } from 'src/actions/invite'
import { InviteAnotherHomeowner } from 'src/constants/trackingEvents'
import { dispatchEvent } from 'src/helpers/tagManager'
import { selectInviteSending } from 'src/store/selectors/invite'
import { Button, FormField, Text } from 'src/Components'
import {
  FIRST_NAME,
  LAST_NAME,
  EMAIL
} from 'src/Components/shared/FormField/names'

import shareImg from './share.gif'
import styles from './SharePanel.module.scss'

const fieldMap = {
  firstName: FIRST_NAME,
  lastName: LAST_NAME,
  email: EMAIL
}

const SharePanel = () => {
  const dispatch = useDispatch()
  const formRef = useRef()
  const sending = useSelector(selectInviteSending)
  const didSend = usePrev(sending)

  useEffect(() => {
    if (didSend && !sending && formRef.current) {
      Object.keys(fieldMap).forEach(
        k => (formRef.current.elements[k].value = '')
      )
    }
  }, [didSend, sending])

  return (
    <div className={styles.container}>
      <img className={styles.image} src={shareImg} alt='house' />
      <Text element='div' className={styles.header}>
        <FormattedMessage
          id='SharePanel.header'
          defaultMessage='Sharing is caring'
        />
      </Text>
      <Text element='p' className={styles.subheader}>
        <FormattedMessage
          id='SharePanel.subheader'
          defaultMessage='Connect your friends and family to their own Homebot report so they can understand their financial situation and see custom options to better manage their wealth.'
        />
      </Text>

      <form
        className={styles.form}
        ref={formRef}
        onSubmit={e => {
          e.preventDefault()
          dispatchEvent(InviteAnotherHomeowner)
          const data = mapValues(fieldMap, k => e.target.elements[k].value)
          dispatch(sendInvite(data))
        }}
      >
        <div className={styles.stackable}>
          <FormField.FirstName required disabled={sending} />
          <FormField.LastName required disabled={sending} />
        </div>
        <FormField.Email required disabled={sending} />

        <Text element='div' align='center'>
          <Button type='submit' loading={sending}>
            <FormattedMessage
              id='Homeowner.shareForm.submitButton'
              defaultMessage='Send Invite'
            />
          </Button>
        </Text>
      </form>
    </div>
  )
}

export default SharePanel
